<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="manageshipment">
          <div class="container-fluid h-100 p-0">
            <div class="manageshipment__topcontent manageshipment__wrapper">
              <div class="dynamic-component-keep-alive-demo clearfix">
                <div class="button-group p-0">
                  <div class="row m-0">
                    <button
                      class="manageshipment__topcontent--tabs"
                      :class="{
                        'manageshipment__topcontent--selected':
                          selectedtabs === tab.router
                      }"
                      v-for="tab in tabs"
                      :key="tab.id"
                      @click="changeTab(tab.router)"
                    >
                      <p class="text-center">{{ tab.title }}</p>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="d-flex align-items-center m-0 manageshipment__topcontent--filter"
              >
                <div class="pr-2">
                  <span>Filter By</span>
                </div>
                <div class="options__multiselect">
                  <multiselect
                    v-model="selected"
                    :options="filterOptions"
                    placeholder="Select"
                    selectedLabel=""
                    @input="filterChoice"
                    label="text"
                    :select-label="''"
                    :deselect-label="''"
                  >
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                </div>
                <div class="input__model1group">
                  <b-input-group>
                    <b-form-input
                      v-if="!['inboundDate', ''].includes(selected.value)"
                      v-model="searchItem"
                      class="ml-3"
                      :placeholder="`Input ${selected.text}`"
                      type="text"
                    />
                    <b-form-input
                      v-if="selected.value == 'inboundDate'"
                      v-model="dateFrom"
                      class="ml-3"
                      :placeholder="`Select ${selected.text}`"
                      type="date"
                      name="Inbound Date"
                    />
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="text-center" v-if="isLoading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <div v-else>
              <div
                class="paginationCustom"
                v-if="inboundList && inboundList.length > 0"
              >
                <div class="manageshipment__wrapper pt-3 pb-2 showing_entries">
                  <div
                    v-if="selectedtabs === 'failed-inbound'"
                    class="row m-0 tabfailed mb-1"
                  >
                    <button
                      class="mr-3 mb-3"
                      :class="{
                        button_active: tabActiveFailed === item.router
                      }"
                      v-for="(item, i) in secondaryTabs"
                      :key="i"
                      @click="changeSecondaryTabs(item.router)"
                    >
                      {{ item.text }}
                    </button>
                  </div>
                  <p
                    v-if="$route.params.type === 'waiting-inbound'"
                    class="fontstyle__errormsg mb-2"
                  >
                    *All existing lists will await approval from the Andalin
                    team
                  </p>
                  <div>{{ showing }}</div>
                </div>
              </div>
              <div class="manageshipment__mastercontent">
                <List :inboundList="inboundList" :selectedtabs="selectedtabs" />
              </div>
              <div class="row m-0 paginationCustom pt-3">
                <div class="col-md-12 d-flex justify-content-center">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                  >
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end class = managementshipment -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/global/Sidebar.vue'
import List from '@/components/warehouse/inbound/List.vue'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
// eslint-disable-next-line import/no-cycle
import mixin from '@/mixin'

export default {
  name: 'warehouselist',
  components: {
    Sidebar,
    List
  },
  mixins: [mixin],
  data() {
    return {
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      selectedtabs: this.$route.params.type,
      showing: '',
      tabActiveFailed: 'cancelled-inbound',
      inboundList: [],
      tabs: [
        {
          id: 1,
          title: 'Draft',
          router: 'draft'
        },
        {
          id: 2,
          title: 'Waiting Inbound',
          router: 'waiting-inbound'
        },
        {
          id: 3,
          title: 'Inbound',
          router: 'inbound'
        },
        {
          id: 4,
          title: 'Completed Inbound',
          router: 'completed-inbound'
        },
        {
          id: 5,
          title: 'Failed Inbound',
          router: 'failed-inbound'
        }
      ],
      filterOptions: [
        { text: 'All', value: '' },
        { text: 'SKU ID', value: 'skuId' },
        { text: 'Inbound ID', value: 'inboundId' },
        { text: 'Inbound Date', value: 'inboundDate' },
        { text: 'Nomor Pengajuan', value: 'nomorPengajuan' },
        { text: 'Reference Number', value: 'referenceNumber' },
        { text: 'Item Number', value: 'itemNumber' },
        { text: 'Notes', value: 'notes' }
      ],
      secondaryTabs: [
        { text: 'Cancelled', router: 'cancelled-inbound' },
        { text: 'Rejected', router: 'rejected-inbound' }
      ],
      selected: {
        text: 'All',
        value: ''
      },
      searchItem: '',
      dateFrom: ''
    }
  },
  mounted() {
    this.fetchInbound()
  },
  computed: {
    ...mapGetters({
      inbound: 'warehouse/inboundList',
      isLoading: 'warehouse/isLoadingInboundList',
      isError: 'warehouse/errorInboundList'
    })
  },
  methods: {
    changeTab(item) {
      this.currentPage = 1
      this.searchItem = ''
      this.dateFrom = ''
      this.selected = { text: 'All', value: '' }
      this.selectedtabs = item
      this.fetchInbound()
      this.$router
        .push({
          name: 'warehouseList',
          params: { type: item }
        })
        .then(() => {})
    },
    changeSecondaryTabs(item) {
      if (this.tabActiveFailed !== item) {
        this.tabActiveFailed = item
        this.searchItem = ''
        this.dateFrom = ''
        this.selected = { text: 'All', value: '' }
        this.currentPage = 1
        this.fetchInbound()
      }
    },
    async fetchInbound() {
      const filter =
        this.selected.value && this.selected.value == 'inboundDate'
          ? `inboundDate=${this.dateFrom}`
          : `${this.selected.value}=${this.searchItem}`
      const type =
        this.selectedtabs === 'failed-inbound'
          ? this.tabActiveFailed
          : this.selectedtabs
      const { currentPage } = this
      const { perPage } = this
      await this.$store.dispatch('warehouse/FETCH_INBOUND_LIST', {
        type,
        currentPage,
        perPage,
        filter
      })
    },
    filterChoice() {
      if (this.selected.text === 'All') {
        this.searchItem = ''
        this.dateFrom = ''
      }
    },
    getDate(date) {
      let newDate = ''
      if (date) {
        newDate = moment(date).format('YYYY-MM-DD')
      }
      return newDate
    }
  },
  watch: {
    inbound(data) {
      if (data) {
        this.showing = data.show
        this.totalRows = data.totalRecord
        this.inboundList = data.data
      }
    },
    searchItem(value) {
      this.searchItem = value
      const lengthVar = value.length
      // eslint-disable-next-line consistent-return
      setTimeout(() => {
        if (lengthVar !== this.searchItem.length) {
          return false
        }
        this.fetchInbound()
      }, 1000)
    },
    dateFrom(value) {
      this.fetchInbound()
    },
    currentPage(data) {
      this.fetchInbound()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.tabfailed {
  button {
    border-radius: 3px;
    font-size: 12px;
    padding: 5.5px;
    background-color: white;
    color: #1d3354;
    line-height: 1;
    cursor: pointer;
    border: 1px solid #1d3354;
    width: 70px;
  }
  .button_active {
    background-color: #1d3354 !important;
    color: white !important;
    cursor: initial !important;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouse/inboundList/index.vue